export default __webpack_public_path__ + "static/media/duplex_146.e2255a58.png";